export const PICKUP_POINT_HAS_ACTIVE_ORDERS_ERROR_CODE =
  'PICKUP_POINT_HAS_ACTIVE_ORDERS';

const PICKUP_POINT_HAS_ACTIVE_ORDERS_MESSAGE =
  'Нельзя изменить точку самовывоза, пока по ней есть активные заказы';

export function getPickupPointMutationErrorMessage(
  error: unknown,
  fallback: string,
): string {
  const code = (
    error as { response?: { data?: { code?: unknown } } }
  )?.response?.data?.code;

  return code === PICKUP_POINT_HAS_ACTIVE_ORDERS_ERROR_CODE
    ? PICKUP_POINT_HAS_ACTIVE_ORDERS_MESSAGE
    : fallback;
}
